import { render, staticRenderFns } from "./btn-secondary.vue?vue&type=template&id=233b43da&scoped=true&"
import script from "./btn-secondary.vue?vue&type=script&lang=js&"
export * from "./btn-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b43da",
  null
  
)

export default component.exports